module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "room-number-list"
  }, [(_vm.tag === 'label' && !_vm.editIsActive) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.isSelected),
      expression: "room.isSelected"
    }],
    attrs: {
      "name": "rooms",
      "hidden": "",
      "type": "checkbox",
      "disabled": _vm.room.isAssigned,
      "id": _vm.labelFor
    },
    domProps: {
      "checked": Array.isArray(_vm.room.isSelected) ? _vm._i(_vm.room.isSelected, null) > -1 : (_vm.room.isSelected)
    },
    on: {
      "change": function($event) {
        _vm.roomSelected(_vm.room, _vm.index)
      },
      "__c": function($event) {
        var $$a = _vm.room.isSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.room.isSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.room.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.room.isSelected = $$c
        }
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editIsActive) ? _c('div', {
    staticClass: "edit-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.room.codeRoom),
      expression: "room.codeRoom"
    }],
    staticClass: "input-to-edit",
    attrs: {
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.room.codeRoom)
    },
    on: {
      "click": _vm.clickEdit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.room.codeRoom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "delete-icon",
    on: {
      "click": function($event) {
        _vm.onRoomRemove(_vm.room)
      }
    }
  }, [_vm._v("cancel")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editIsActive) ? _c('label', {
    staticClass: "room-number",
    class: {
      'disabled': _vm.room.isAssigned, 'active': _vm.room.isSelected
    },
    attrs: {
      "for": _vm.labelFor
    },
    on: {
      "click": function($event) {
        _vm.goToLink(_vm.link)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.room.codeRoom))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-668d8886","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RoomNumberList.vue
// module id = 749
// module chunks = 108